define.alias("ember-math-helpers/helpers/acos", "media/helpers/acos");